<template>
    <div class="min-h-screen w-full flex flex-col bg-gradient-to-br from-gray-100 to-blue-50">
        <div class="container mx-auto my-4 sm:my-8 px-4 sm:px-8">
            <div class="mb-4">
                <bread-crumb :items="breadCrumbItems"></bread-crumb>
            </div>

            <coming-soon
                :title="pageTitle"
                :show-button="true"
                button-text="Coming Soon"
                button-icon="clock"
            />
        </div>
    </div>
</template>

<script>
import BreadCrumb from "../../components/shared/BreadCrumb.vue";
import { getCampusConfig, isValidCampus } from "./config";

export default {
    name: "adpoly-contractors",
    components: {
        BreadCrumb,
    },
    props: ["campus"],
    created() {
        this.validateCampus();
    },
    watch: {
        campus: function () {
            this.validateCampus();
        },
    },
    computed: {
        campusConfig() {
            return getCampusConfig(this.campus);
        },
        campusTitle() {
            return this.campusConfig ? this.campusConfig.title : "";
        },
        campusKey() {
            return this.campusConfig ? this.campusConfig.key : "";
        },
        pageTitle() {
            if (!this.campusTitle) return "Contractors";
            return this.campusTitle + " - Contractors";
        },
        breadCrumbItems() {
            return [
                { label: "Dashboard", path: "/dashboard" },
                { label: "ADPOLY", path: "/adpoly" },
                {
                    label: this.campusTitle || "Campus",
                    path: this.campusKey ? "/adpoly/" + this.campusKey : "/adpoly",
                },
                {
                    label: "Campus",
                    path: this.campusKey
                        ? "/adpoly/" + this.campusKey + "/campus"
                        : "/adpoly",
                },
                {
                    label: "People",
                    path: this.campusKey
                        ? "/adpoly/" + this.campusKey + "/campus/people"
                        : "/adpoly",
                },
                { label: "Contractors" },
            ];
        },
    },
    methods: {
        validateCampus() {
            if (!isValidCampus(this.campus)) {
                this.$router.push({ path: "/notFound" });
            }
        },
    },
};
</script>
